import { Component } from 'solid-js'
import Tabs, { useTabs } from '/web/shared/Tabs'
import { MessageUISettings } from './ui/MessageUISettings'
import { ChatUISettings } from './ui/ChatUISettings'
import { ThemeUISettings } from './ui/ThemeUISettings'
import { i18nStore } from '../../store'

const UISettings: Component<{}> = () => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const tabs = useTabs([i18n.t.settings_ui_theme, i18n.t.settings_ui_chat, i18n.t.settings_ui_messages])

  return (
    <>
      <Tabs tabs={tabs.tabs()} select={tabs.select} selected={tabs.selected} />

      <div classList={{ hidden: tabs.current() !== i18n.t.settings_ui_theme }}>
        <ThemeUISettings />
      </div>

      <div classList={{ hidden: tabs.current() !== i18n.t.settings_ui_chat }}>
        <ChatUISettings />
      </div>

      <div classList={{ hidden: tabs.current() !== i18n.t.settings_ui_messages }}>
        <MessageUISettings />
      </div>
    </>
  )
}

export default UISettings
